<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script lang="ts" setup>
import { RouterView } from "vue-router";
import { onMounted } from "vue";
import { useToast } from "vue-toast-notification";
import { CHUNK_RELOAD } from "@/functional/storage/sessionStorageKeys.ts";

onMounted(() => {
  if (sessionStorage.getItem(CHUNK_RELOAD)) {
    sessionStorage.removeItem(CHUNK_RELOAD);
    const toast = useToast();
    toast.info(
      "A new version of the app was detected: page refreshed automatically",
    );
  }
});
</script>

<style>
@import "@/assets/styles/base.css";
@import "@/assets/styles/general.css";
</style>
